// Version : 0.0.1
// Author : VISHAL BHARATHI
// LastEdit : VISHAL BHARATHI
// Last ADD : GOLD CLOSE LOAN ACTION CREATED
// MODIFIED DATE: 23-08-2025

import GoldCloseLoanActionTypes from './gold-close-loan.types';

/** ***************** GET GOLD LOAN MEMBER DETAILS START *********************** */
export const getGoldLoanMemberDetailsStart = (getData: any) => ({
	type: GoldCloseLoanActionTypes.GET_GOLD_LOAN_MEMBER_DETAILS_START,
	payload: getData,
});

export const getGoldLoanMemberDetailsSuccess = (successData: any) => ({
	type: GoldCloseLoanActionTypes.GET_GOLD_LOAN_MEMBER_DETAILS_SUCCESS,
	payload: successData,
});

export const getGoldLoanMemberDetailsFailure = (failureData: any) => ({
	type: GoldCloseLoanActionTypes.GET_GOLD_LOAN_MEMBER_DETAILS_FAILURE,
	payload: failureData,
});

export const getGoldLoanMemberDetailsResponseResetStart = () => ({
	type: GoldCloseLoanActionTypes.GET_GOLD_LOAN_MEMBER_DETAILS_RESPONSE_RESET,
});

export const getGoldLoanMemberDetailsResponseChanged = () => ({
	type: GoldCloseLoanActionTypes.GET_GOLD_LOAN_MEMBER_DETAILS_RESPONSE_CHANGED,
});
/** ***************** GET GOLD LOAN MEMBER DETAILS END *********************** */

/** ***************** UPDATE GOLD CLOSE DETAILS START *********************** */
export const updateGoldCloseDetailsStart = (getData: any) => ({
	type: GoldCloseLoanActionTypes.UPDATE_GOLD_CLOSE_DETAILS_START,
	payload: getData,
});

export const updateGoldCloseDetailsSuccess = (successData: any) => ({
	type: GoldCloseLoanActionTypes.UPDATE_GOLD_CLOSE_DETAILS_SUCCESS,
	payload: successData,
});

export const updateGoldCloseDetailsFailure = (failureData: any) => ({
	type: GoldCloseLoanActionTypes.UPDATE_GOLD_CLOSE_DETAILS_FAILURE,
	payload: failureData,
});

export const updateGoldCloseDetailsResponseResetStart = () => ({
	type: GoldCloseLoanActionTypes.UPDATE_GOLD_CLOSE_DETAILS_RESPONSE_RESET,
});

export const updateGoldCloseDetailsResponseChanged = () => ({
	type: GoldCloseLoanActionTypes.UPDATE_GOLD_CLOSE_DETAILS_RESPONSE_CHANGED,
});
/** ***************** UPDATE GOLD CLOSE DETAILS END *********************** */
